angular.module('ikeweb.spike.measure').controller('MeasurementsDetailController', ['$scope', 'selectedMeasurementService', 'measurementService',
    'pubSubService', 'measureTopics',
    function($scope, selectedMeasurementService, measurementService, pubSubService, measureTopics) {
        var self = this;

        function getMeasurements() {
            return self.measurements || [];
        }

        function isSelectedMeasurement(id) {
            var measurement = selectedMeasurementService.getMeasurement();
            return !!measurement && measurement.getId() === id;
        }

        function isMeasurementActive(id) {
            return !!self.activeMeasurement && self.activeMeasurement.id === id;
        }

        function getAreas() {
            return measurementService.getAreas(getMeasurements());
        }

        function getCutouts() {
            return measurementService.getCutouts(getMeasurements());
        }

        function getAreaMinusCutouts() {
            return measurementService.getAreaMinusCutouts(getMeasurements());
        }

        function getLines() {
            return measurementService.getLines(getMeasurements());
        }

        function setSelected(measurement) {
            selectedMeasurementService.setMeasurement(measurement);
        }

        function updateSelectedMeasurement() {
            var measurement = selectedMeasurementService.getMeasurement();
            if (measurement) {
                var newMeasurement = measurementService.getMeasurement(measurement.getId(), getMeasurements());
                setSelected(newMeasurement);
            }
        }

        function noteUpdated() {
            pubSubService.publish(measureTopics.NOTE.UPDATE, self.note);
        }

        self.getAreas = getAreas;
        self.getCutouts = getCutouts;
        self.getAreaMinusCutouts = getAreaMinusCutouts;
        self.getLines = getLines;
        self.setSelected = setSelected;
        self.isSelectedMeasurement = isSelectedMeasurement;
        self.isMeasurementActive = isMeasurementActive;
        self.getMeasurements = getMeasurements;
        self.updateSelectedMeasurement = updateSelectedMeasurement;
        self.noteUpdated = noteUpdated;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurements-detail/measurements.detail.controller.js
// module id = 569
// module chunks = 0